// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "spot-fe-data/trade/spot/pro/static/css/" + chunkId + "." + {"864":"9233c70a","1566":"abb901e5","1698":"385fa68b","2172":"febd4773","2466":"ac7a7dc3","3449":"09af0d24","3682":"7fe086e2","8318":"3b1c641b","9055":"37444192","9076":"a0fb534d","9805":"2703b3b4"}[chunkId] + ".css";
};